// import React, { useState, useEffect } from "react";
// import { Icon } from "@iconify/react/dist/iconify.js";
// import { parse, format, setWeekYear } from "date-fns";
// import PrimaryButton from "../buttons/PrimaryButton";
// import Skeleton from "react-loading-skeleton";
// import "react-loading-skeleton/dist/skeleton.css";
// import Cookies from "js-cookie";
// import Pagination from "../pagination/Pagination";

// const SectorsTable = ({ searchQuery, startDate, endDate, activeTab }) => {
//   const [currentPage, setCurrentPage] = useState(1);
//   const [loading, setLoading] = useState(false);
//   const [archiveData, setArchiveData] = useState([]);
//   const entriesPerPage = 10;
//   const [filteredData, setFilteredData] = useState([]);
//   const [indexedRecords, setIndexedRecords] = useState([]);
//   const [yellowForms, setYellowForms] = useState([]);

//   const baseUrl = process.env.REACT_APP_BASE_URL;

//   useEffect(() => {
//     const fetchIndexedRecords = async () => {
//       const token = Cookies.get("token");
//       setLoading(true);
//       try {
//         const response = await fetch(
//           `${baseUrl}/api/index/indexed-records/history`,
//           {
//             headers: { Authorization: `Bearer ${token}` },
//           }
//         );
//         if (!response.ok) throw new Error("Failed to fetch archives");

//         const data = await response.json();
//         setIndexedRecords(data || []);
//       } catch (error) {
//         console.error("Error fetching indexed records");
//       } finally {
//         setLoading(false);
//       }
//     };

//     const fetchYellowForms = async () => {
//       const token = Cookies.get("token");
//       setLoading(true);
//       try {
//         const response = await fetch(`${baseUrl}/api/yellow-forms/history`, {
//           headers: { Authorization: `Bearer ${token}` },
//         });
//         if (!response.ok) throw new Error("Failed to fetch yellow forms");

//         const data = await response.json();
//         setYellowForms(data || []);
//       } catch (error) {
//         console.error("Error fetching yellow forms");
//       } finally {
//         setLoading(false);
//       }
//     };

//     setFilteredData([]);
//     if (activeTab === "indexed-records") {
//       fetchIndexedRecords();
//     } else {
//       fetchYellowForms();
//     }
//   }, [baseUrl, activeTab]);

//   const capitalize = (string) => {
//     if (!string) return "";
//     return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
//   };

//   const transformIndexedRecords = (data) => {
//     return data.map((item) => ({
//       province: item.site?.site.province,
//       district: item.site?.site.district,
//       sector: item.site?.site.sector || "-",
//       bookName: item.book.name,
//       bookType: capitalize(item.book.bookType),
//       count: item.count || 0,
//       assignedTo: item.assignedToClerk?.name || "-",
//       status: item.status,
//       recordedAt: format(new Date(item.createdAt), "dd-MM-yyyy"),
//       createdAt: item.createdAt,
//     }));
//   };

//   const transformYellowForms = (data) => {
//     return data.map((item) => ({
//       province: item.site?.site.province,
//       district: item.site?.site.district,
//       sector: item.site?.site.sector || "-",
//       yellowFormCount: item.yellowFormCount || 0,
//       assignedTo: item.assignedToClerk?.name || "-",
//       status: item.status,
//       recordedAt: format(new Date(item.createdAt), "dd-MM-yyyy"),
//       createdAt: item.createdAt,
//     }));
//   };

//   useEffect(() => {
//     const handleFilters = () => {
//       let data =
//         activeTab === "indexed-records"
//           ? transformIndexedRecords(indexedRecords)
//           : transformYellowForms(yellowForms);

//       // Search filter
//       if (searchQuery?.trim()) {
//         data = data.filter((item) =>
//           [item.district, item.sector].some((field) =>
//             field?.toLowerCase().includes(searchQuery.toLowerCase())
//           )
//         );
//       }

//       // Date filter
//       if (startDate && endDate) {
//         const start = new Date(startDate);
//         start.setHours(0, 0, 0, 0);
//         const end = new Date(endDate);
//         end.setHours(23, 59, 59, 999);

//         data = data.filter((item) => {
//           const itemDate = new Date(item.createdAt);
//           return itemDate >= start && itemDate <= end;
//         });
//       }

//       setFilteredData(data);
//     };

//     handleFilters();
//   }, [activeTab, indexedRecords, yellowForms, searchQuery, startDate, endDate]);

//   const indexOfLastEntry = currentPage * entriesPerPage;
//   const indexOfFirstEntry = indexOfLastEntry - entriesPerPage;
//   const currentEntries = filteredData.slice(
//     indexOfFirstEntry,
//     indexOfLastEntry
//   );

//   const indexedRecordsColumns = [
//     "Province",
//     "District",
//     "Sector",
//     "Book Name",
//     "Book Type",
//     "Count",
//     "Status",
//     "Recorded At",
//   ];

//   const yellowFormsColumns = [
//     "Province",
//     "District",
//     "Sector",
//     "Yellow Form Count",
//     "Status",
//     "Recorded At",
//   ];

//   const formatDate = (dateString) => {
//     const parsedData = parse(dateString, "dd-MM-yyyy", new Date());
//     return format(parsedData, "dd MMM yyyy");
//   };

//   const getStatusClass = (status) => {
//     const statusMap = {
//       APPROVED: "status-approved",
//       REJECTED: "status-declined",
//       PENDING: "status-pending",
//     };
//     return `status ${statusMap[status]}`;
//   };

//   const formatStatus = (status) => {
//     if (!status) return "";
//     if (status.toUpperCase() === "REJECTED") return "Declined";
//     return status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();
//   };

//   return (
//     <>
//       <table>
//         <thead>
//           <tr>
//             {(activeTab === "indexed-records"
//               ? indexedRecordsColumns
//               : yellowFormsColumns
//             ).map((header, index) => (
//               <th key={index}>{header}</th>
//             ))}
//           </tr>
//         </thead>
//         <tbody>
//           {loading ? (
//             Array.from({ length: 5 }).map((_, index) => (
//               <tr key={index}>
//                 <td>
//                   <Skeleton width={20} height={20} />
//                 </td>
//                 <td>
//                   <Skeleton width={100} />
//                 </td>
//                 <td>
//                   <Skeleton width={150} />
//                 </td>
//                 <td>
//                   <Skeleton width={100} />
//                 </td>
//                 <td>
//                   <Skeleton width={80} />
//                 </td>
//                 <td>
//                   <Skeleton width={100} />
//                 </td>
//               </tr>
//             ))
//           ) : filteredData.length === 0 ? (
//             <tr style={{ boxShadow: "none" }}>
//               <td colSpan="7" style={{ textAlign: "center", color: "#9B9B9B" }}>
//                 No data found
//               </td>
//             </tr>
//           ) : (
//             // replace with currentEntries once fetched
//             currentEntries.map((item, index) => (
//               <tr key={index}>
//                 <td>{item.province}</td>
//                 <td>{item.district}</td>
//                 <td>{item.sector}</td>
//                 {activeTab === "indexed-records" ? (
//                   <>
//                     <td>{item.bookName}</td>
//                     <td>{item.bookType}</td>
//                     <td>{item.count}</td>
//                   </>
//                 ) : (
//                   <td>{item.yellowFormCount}</td>
//                 )}
//                 <td>
//                   <span className={getStatusClass(item.status)}>
//                     {formatStatus(item.status)}
//                   </span>
//                 </td>
//                 <td>{formatDate(item.recordedAt)}</td>
//               </tr>
//             ))
//           )}
//         </tbody>
//       </table>
//       {!loading && filteredData.length > 0 && (
//         <Pagination
//           currentPage={currentPage}
//           totalItems={filteredData.length}
//           entriesPerPage={entriesPerPage}
//           onPageChange={setCurrentPage}
//         />
//       )}
//     </>
//   );
// };

// export default SectorsTable;




import React from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import { parse, format } from "date-fns";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import Pagination from "../pagination/Pagination";
import PageSizeSelector from "../pagination/PageSizeSelector";
import usePaginatedData from "../pagination/hooks/usePaginatedData";

const SectorsTable = ({ searchQuery, startDate, endDate, activeTab }) => {
  // Configuration for endpoints and transform functions
  const endpoints = {
    "indexed-records": `/api/index/indexed-records/history`,
    "yellow-forms": `/api/yellow-forms/history`
  };

  // Custom transform functions for the sectors table
  const transformFunctions = {
    'indexed-records': (data) => {
      return data.map((item) => ({
        id: item.id,
        province: item.site?.site?.province || "-",
        district: item.site?.site?.district || "-",
        sector: item.site?.site?.sector || "-",
        bookName: item.book?.name || "-",
        bookType: capitalize(item.book?.bookType) || "-",
        count: item.count || 0,
        assignedTo: item.assignedToClerk?.name || "-",
        status: item.status || "PENDING",
        recordedAt: format(new Date(item.createdAt), "dd-MM-yyyy"),
        createdAt: item.createdAt,
      }));
    },
    'yellow-forms': (data) => {
      return data.map((item) => ({
        id: item.id,
        province: item.site?.site?.province || "-",
        district: item.site?.site?.district || "-",
        sector: item.site?.site?.sector || "-",
        yellowFormCount: item.yellowFormCount || 0,
        assignedTo: item.assignedToClerk?.name || "-",
        status: item.status || "PENDING",
        recordedAt: format(new Date(item.createdAt), "dd-MM-yyyy"),
        createdAt: item.createdAt,
      }));
    }
  };

  // Use the pagination hook
  const {
    data: filteredData,
    pagination,
    loading,
    error: fetchError,
    goToPage,
    changePageSize,
    refresh
  } = usePaginatedData({
    activeTab,
    searchQuery,
    startDate,
    endDate,
    endpoints,
    transformFunctions
  });

  const capitalize = (string) => {
    if (!string) return "";
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
  };

  const handlePageChange = (newPage) => {
    goToPage(newPage);
  };

  const handlePageSizeChange = (event) => {
    const newPageSize = parseInt(event.target.value);
    changePageSize(newPageSize);
  };

  const indexedRecordsColumns = [
    "Province",
    "District",
    "Sector",
    "Book Name",
    "Book Type",
    "Count",
    "Status",
    "Recorded At",
  ];

  const yellowFormsColumns = [
    "Province",
    "District",
    "Sector",
    "Yellow Form Count",
    "Status",
    "Recorded At",
  ];

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const parsedData = parse(dateString, "dd-MM-yyyy", new Date());
    return format(parsedData, "dd MMM yyyy");
  };

  const getStatusClass = (status) => {
    const statusMap = {
      APPROVED: "status-approved",
      REJECTED: "status-declined",
      PENDING: "status-pending",
    };
    return `status ${statusMap[status]}`;
  };

  const formatStatus = (status) => {
    if (!status) return "";
    if (status.toUpperCase() === "REJECTED") return "Declined";
    return status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();
  };

  return (
    <>
      {/* Page Size Selector */}
      <div className="table-header-controls">
        <PageSizeSelector
          value={pagination.itemsPerPage}
          onChange={handlePageSizeChange}
          disabled={loading}
        />
        
        {/* Show error message if fetch failed */}
        {fetchError && (
          <div className="error-message">
            <span style={{ color: "#E20000", marginRight: "10px" }}>
              Error: {fetchError}
            </span>
            <button 
              onClick={refresh} 
              className="retry-button"
              disabled={loading}
            >
              <Icon icon="iconamoon:restart" width="16" height="16" />
              Retry
            </button>
          </div>
        )}
      </div>

      <table>
        <thead>
          <tr>
            {(activeTab === "indexed-records"
              ? indexedRecordsColumns
              : yellowFormsColumns
            ).map((header, index) => (
              <th key={index}>{header}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {loading ? (
            Array.from({ length: 5 }).map((_, index) => (
              <tr key={index}>
                <td>
                  <Skeleton width={100} />
                </td>
                <td>
                  <Skeleton width={150} />
                </td>
                <td>
                  <Skeleton width={100} />
                </td>
                <td>
                  <Skeleton width={80} />
                </td>
                <td>
                  <Skeleton width={100} />
                </td>
                <td>
                  <Skeleton width={100} />
                </td>
                {activeTab === "indexed-records" && (
                  <>
                    <td>
                      <Skeleton width={80} />
                    </td>
                    <td>
                      <Skeleton width={100} />
                    </td>
                  </>
                )}
              </tr>
            ))
          ) : filteredData.length === 0 ? (
            <tr style={{ boxShadow: "none" }}>
              <td 
                colSpan={activeTab === "indexed-records" ? "8" : "6"} 
                style={{ textAlign: "center", color: "#9B9B9B" }}
              >
                No data found
              </td>
            </tr>
          ) : (
            filteredData.map((item) => (
              <tr key={item.id}>
                <td>{item.province}</td>
                <td>{item.district}</td>
                <td>{item.sector}</td>
                {activeTab === "indexed-records" ? (
                  <>
                    <td>
                      {item.bookName
                        ? item.bookName === "Special_category"
                          ? "Special Category"
                          : item.bookName
                        : "-"}
                    </td>
                    <td>{item.bookType}</td>
                    <td>{item.count}</td>
                  </>
                ) : (
                  <td>{item.yellowFormCount}</td>
                )}
                <td>
                  <span className={getStatusClass(item.status)}>
                    {formatStatus(item.status)}
                  </span>
                </td>
                <td>{formatDate(item.recordedAt)}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>

      {/* Updated Pagination */}
      {!loading && pagination.totalPages > 1 && (
        <Pagination
          currentPage={pagination.currentPage}
          totalItems={pagination.totalItems}
          entriesPerPage={pagination.itemsPerPage}
          onPageChange={handlePageChange}
        />
      )}
    </>
  );
};

export default SectorsTable;